import React from 'react'
import "./Footer.css"

function Footer() {
  return (
    <>
    <div className='footer'>
        <div className='author'>
        <p>Created by <a href="https://drive.google.com/drive/folders/1zc8yyK0RNFRhxWLLXAJG2TTIqBPFraBX?usp=sharing" target="_blank" rel="noopener noreferrer">Deepak Bisht</a> with <i className='far fa-heart'></i></p>
        </div>
        <span className=''>
        <span className='copyright'> <i className='far fa-copyright'></i> 2022 All rights reserved</span>
        </span>
    </div>
    </>
  )
}

export default Footer
